import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import DeleteAccountConfirmPage from '@/features/account/delete-account-confirm';
import { IdentityRouteGuard } from '@/features/account/identity-confirmation';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/perfil/excluir-conta/')({
  component: () => (
    <HomeGate>
      <IdentityRouteGuard target="delete-account">
        <DeleteAccountConfirmPage />
      </IdentityRouteGuard>
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
